import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	recent: {
		defaultMessage: 'Recent',
		id: 'atlassian-navigation.dashboards.menu.recent-content.recent',
		description: 'Recent dashboard item',
	},
	viewAll: {
		defaultMessage: 'View all recent',
		id: 'atlassian-navigation.dashboards.menu.recent-content.view-all',
		description: 'View all recent dashboard item',
	},
});
